import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {
  WebReserveLinkReqResource,
} from '@blcloud/bl-ng-resource';
import {
  ICustomerInfo,
  IVehicleInfo,
  IWebReserveLinkReq,
  CustomerInfo,
} from '@blcloud/bl-datamodel';
import { BlDialogService } from '@blcloud/bl-ng-ui-component';
import { catchError, map } from 'rxjs/operators';
import { of as ObservableOf } from 'rxjs/observable/of';

/**
 * Web予約顧客車両紐付サービス
 */
@Injectable()
export class WebReserveReceptionLinkService {

  constructor(
    private dialogService: BlDialogService,
    private webReserveLinkReqResource: WebReserveLinkReqResource,
  ) { }

  /**
   * 顧客車両情報ヘッダ表示情報取得
   * @param customerInfo
   * @param vehicleInfo
   */
  getCustomerVehicleInfo(customerInfo: ICustomerInfo, vehicleInfo: IVehicleInfo): Observable<any> {
    const data = {
      customerName: customerInfo.customerName1,
      customerNameKana: customerInfo.customerNameDisplayKana,
      contact: CustomerInfo.dispCustomerHeadTel(customerInfo),
      vehicleName: this.dispVehicleMakerName(vehicleInfo) + ' ' + this.dispVehicleName(vehicleInfo)
    };
    return ObservableOf(data);
  }

  /**
   * 表示用メーカー名称取得
   * @return string
   */
  private dispVehicleMakerName(vehicleInfo: IVehicleInfo): string {
    if (!vehicleInfo || !vehicleInfo.vehicleInspCertifInfo) {
      return '';
    }
    return vehicleInfo.vehicleInspCertifInfo.blVehicleMakerFullWFixNm || '';
  }

  /**
   * 表示用車名取得
   * @param vehicleInfo
   */
  private dispVehicleName(vehicleInfo: IVehicleInfo): string {
    if (!vehicleInfo || !vehicleInfo.vehicleSpecificationInfo) {
      return '';
    }
    return vehicleInfo.vehicleSpecificationInfo.vehicleModelFixFullWName || '';
  }

  /**
   * Web予約情報と受付情報の候補を紐付ける
   *
   * @param webReserveLinkReq Web予約情報紐付要求
   */
  linkWebReserve(webReserveLinkReq: IWebReserveLinkReq): Observable<IWebReserveLinkReq> {
    return this.webReserveLinkReqResource.post<IWebReserveLinkReq>(
      webReserveLinkReq,
      {
        subject: 'common',
      },
      ).pipe(
        map(
          response => {
            return response;
          }
        ),
        catchError(err => {
          this.dialogService.info(err.messages[0])
            .subscribe(blModalRef => {
              blModalRef.hide();
            });
          return ObservableOf(undefined);
        })
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/web-reserve-reception-link/web-reserve-reception-link.service.ts